export * from './tags';
export * from './createTag';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Tags/index.js
// module id = 1193
// module chunks = 0